import { uiTokens } from '@/theme/uiTokens';

export type MetricsPalette = {
  pass: string;
  fail: string;
  error: string;
  skip: string;
  neutral: string;
  frequency: string;
  flake: string;
  greenTime: string;
  mttf: string;
  duration: string;
};

export const buildMetricsPalette = (): MetricsPalette => ({
  pass: uiTokens.statusColors.green,
  fail: uiTokens.statusColors.red,
  error: uiTokens.statusColors.brown,
  skip: uiTokens.statusColors.orange,
  neutral: uiTokens.statusColors.neutral,
  frequency: uiTokens.statusColors.green,
  flake: uiTokens.statusColors.orange,
  greenTime: uiTokens.statusColors.green,
  mttf: uiTokens.statusColors.brown,
  duration: uiTokens.statusColors.green,
});
